import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { DocumentHistoryDataSource } from './document-history.datasource';
import { DocumentHistoryService } from '../services/document-history.service';
import {Document} from '../models/Document';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { map } from 'rxjs/operators';
import { DocumentHistory } from '../models/DocumentHistory';
import { HistoryPagedDataSource } from '../../base/table/paged-table-history.datasource';

@Component({
  selector: 'app-document-history',
  templateUrl: './document-history.component.html',
  styleUrls: ['./document-history.component.css']
})
export class DocumentHistoryComponent implements OnChanges, OnInit {

  public dataSource: HistoryPagedDataSource<DocumentHistory>;
  public displayedColumns = ['actions', 'date'];

  @Input() document: Document;
  constructor(
    private historyService: DocumentHistoryService,
    private router: Router,
    private dialog: MatDialog,
  ) { }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.document && changes.document.currentValue && changes.document.currentValue !== changes.document.previousValue) {
      if (changes.document.currentValue && changes.document.previousValue) {
        if (changes.document.previousValue.id !== changes.document.currentValue.id) {
          const filter: any = {
            parentId: changes.document.currentValue.id
          };
          this.dataSource = new HistoryPagedDataSource<DocumentHistory>(this.historyService,
            changes.document.currentValue.id, filter, 'created', 'desc');
          this.dataSource.loadData();
        }
      }
    }
  }
  OnShow(row: any) {
    if (row.id) {
      this.router.navigate(['/document/history', row.id]);
    }
  }
  private ConrimDelete(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.deleteRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  OnDelete(row: any) {
    this.ConrimDelete(row.name).subscribe((ret) => {
      if (ret) {
        this.historyService.Delete(row.id).subscribe(() => {
          const filter: any = {
            parentId: this.document.id
          };
          this.dataSource = new HistoryPagedDataSource<DocumentHistory>(this.historyService,
            this.document.id, filter, 'created', 'desc');
          this.dataSource.loadData();
        });
      }
    });
  }
}
